// extracted by mini-css-extract-plugin
export default {"privacy-terms-content":"styles_privacy-terms-content__EhJBx","ordered-list":"styles_ordered-list__bkKo5"};